import { UrlConfig } from '@api/models/common';

export const staticURLs: UrlConfig = {
	facebook: 'https://www.facebook.com/salmonphilippines',
	facebookChat: 'https://m.me/salmonphilippines',
	salmonLaunch: 'http://app.salmon.ph/launch',
};
